<script setup lang="ts">
import ButtonIcon from '../ButtonIcon.vue';

const props = defineProps<{
	title?: string;
	closeLabel?: string;
	isActive?: boolean;
}>();

const emit = defineEmits<{
	'update:isActive': [value: boolean];
	'close': [];
}>();

const closeMore = () => {
	emit('update:isActive', false);
	emit('close');
};
</script>

<template>
	<div
		class="bottom-dialog-more"
		role="document"
		id="bottom-dialog-more"
	>
		<div class="bottom-dialog-more__header">
			<span
				class="bottom-dialog-more__title"
				id="bottom-dialog-more-title"
			>
				{{ props.title }}
			</span>
			<ButtonIcon
				icon="x"
				severity="error"
				size="sm"
				:label="props.closeLabel"
				@click="closeMore()"
			/>
		</div>
		<div class="bottom-dialog-more__body">
			<slot />
		</div>
		<div class="bottom-dialog-more__footer" v-if="$slots.footer">
			<slot name="footer" />
		</div>
	</div>
</template>

<style scoped lang="scss">
@layer hm-components
{
	.bottom-dialog-more
	{
		@include flex;
		flex-direction:column;

		&__header
		{
			@include flex(between, center, 16);
			border-block-end:1px solid var(--bg-basic-200);
			padding-block-end:$spacing-xs;
		}
		&__title
		{
			color:var(--text-basic-900);
			font-size:1.6rem;
			font-weight:500;
		}
		&__body
		{
			@include flex;
			flex-direction:column;
			max-height:calc(100dvh - 17.6rem);
			padding:$spacing-md 0;
			overflow-y:auto;

			@include responsive(lg)
			{
				max-height:calc(100dvh - 20rem);
				padding-inline:$spacing-xs;
			}
		}
		&__footer
		{
			@include flex(end, center, 8);
			border-block-start:1px solid var(--bg-basic-200);
			padding-block-start:$spacing-xs;
		}
	}
}
</style>
